import { Outlet } from "react-router-dom";
import Sidebar from "../panel/component/Sidebar";
import TopBar from "../panel/component/TopBar";

const PUBLIC_URL = process.env.PUBLIC_URL;

// `bare` = only load panel styles (used by /login, /pin etc.), no Sidebar/TopBar
export default function PanelLayout({ bare = false }) {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@500;700&display=swap"
        precedence="default"
      />
      <link
        rel="stylesheet"
        href={`${PUBLIC_URL}/assets/panel/style.css`}
        precedence="default"
      />

      {bare ? (
        <Outlet />
      ) : (
        <div className="shell active">
          <Sidebar />
          <div className="main">
            <TopBar />
            <div className="content">
              <Outlet />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
